import React, { useEffect, } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap'
import { format } from 'date-fns';

function Detalhes(props) {
    const { socket, serial, setLoading, details } = props;

    useEffect(() => {
        const handleGetConfigs = () => {
            if (!serial) {
                console.log("Sem serial!");
                return
            }
            setLoading(true)
            socket.send(
                JSON.stringify({
                    type: 'message',
                    room: serial,
                    content: {
                        command: 'web_browser',
                        parameters: {
                            value: 'get_details',
                            page: 'details'
                        }
                    },
                })
            );
        };
        handleGetConfigs()
    }, [serial])

    return (
        <Card className='p-3 mb-3' style={{ background: '#f4f4f4' }}>
            <Row>
                <h3>Detalhes</h3>
                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>Serial</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="text"
                        name="serial"
                        value={details && details.serial ? details.serial : ''}
                        disabled={true}
                    />
                </Col>

                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>Empresa</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="text"
                        name="companhia"
                        value={details && details.companhia ? details.companhia : ''}
                        disabled={true}
                    />
                </Col>

                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>details de Ativação</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="details"
                        name="activation_date"
                        value={details && details.activation_date ? format(new Date(details.activation_date), 'dd/MM/yyyy HH:mm:ss') : ''}
                        disabled={true}
                    />
                </Col>

                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>Versão de Software</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="text"
                        name="v_software"
                        value={details && details.v_software ? details.v_software : ''}
                        disabled={true}
                    />
                </Col>

                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>Versão Osciladora</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="text"
                        name="v_firmware_osc"
                        value={details && details.v_firmware_osc ? details.v_firmware_osc : ''}
                        disabled={true}
                    />
                </Col>

                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>Versão de Firmware</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="text"
                        name="v_firmware"
                        value={details && details.v_firmware ? details.v_firmware : ''}
                        disabled={true}
                    />
                </Col>

                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>Dias para Ativação</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="number"
                        name="activation_days"
                        value={details && details.activation_days ? details.activation_days : ''}
                        disabled={true}
                    />
                </Col>

                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>ID Calibração</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="text"
                        name="calib_id"
                        value={details && details.calib_id ? details.calib_id : ''}
                        disabled={true}
                    />
                </Col>

                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <Form.Label>Frequência vazio</Form.Label>
                    <Form.Control
                        className="mb-3"
                        type="number"
                        name="freq_v"
                        value={details && details.freq_v ? details.freq_v : ''}
                        disabled={true}
                    />
                </Col>

            </Row>
        </Card>
    );
}

export default Detalhes;
